module.exports = __webpack_public_path__ + "media/assets/images/movimenta-logo0-272b559572ab8892bbf9b312d6db73ff.svg";